// Le mini-jeu « Débusque l'arnaque » : une offre découpée en phrases, dont
// certaines sont des signaux d'alerte à repérer.
import type { TextKey } from './fr';

export interface ScamSegment {
  text: TextKey;
  flag: boolean;
  why?: TextKey;
}

export const SCAM_SEGMENTS: ScamSegment[] = [
  { text: 'scam.s1', flag: false },
  { text: 'scam.s2', flag: true, why: 'scam.why.s2' },
  { text: 'scam.s3', flag: true, why: 'scam.why.s3' },
  { text: 'scam.s4', flag: false },
  { text: 'scam.s5', flag: true, why: 'scam.why.s5' },
  { text: 'scam.s6', flag: false },
  { text: 'scam.s7', flag: true, why: 'scam.why.s7' },
  { text: 'scam.s8', flag: true, why: 'scam.why.s8' },
  { text: 'scam.s9', flag: false },
];

export const SCAM_SECONDS = 30;
/** Il faut trouver au moins trois signaux, avec au plus une erreur. */
export const SCAM_MIN_FOUND = 3;
export const SCAM_MAX_WRONG = 1;
export const SCAM_REWARD_SUCCESS = 5;
export const SCAM_REWARD_FAIL = 1;
